export default "__VITE_ASSET__DxLa4oj8__"